(function( $ ){
  //   $(document).on('mouseover', '.f-site-nav__item details', function() {
  //     console.log("hovered");
  //     $(this).attr('open', 'open');
  //   });
  
  $(document).on('click', '.f-mobile-nav__link', function() {
    $(this).parent().find('.f-mobile-nav__arrow').trigger('click');
  });
})( jQuery );

setTimeout(function() {
(function( $ ){
$('.recomm-product').owlCarousel({
    loop:true,
    margin:10,
    items:1,
    nav: true,
    navText:["<div class='nav-btn prev-slide'><</div>","<div class='nav-btn next-slide'>></div>"]
 
    
});
 })( jQuery );
     }, 1000);



